// extracted by mini-css-extract-plugin
export default {"tableContainer":"CompanyList_tableContainer__cDNkh","logo":"CompanyList_logo__LQCD+","table":"CompanyList_table__NN5tB"};